<template>
    <div class="page">
        <div class="main_body">
                <div class="top_label">
                    <span class="lable_name">自主学习</span>

                </div>

                <div class="stattistic_search_box">
                    <div class="search_box_left">
                        <span @click="changeTab(0)" :class="{'active':form_data.state == 0}">当前班级</span>
                        <span @click="changeTab(1)" :class="{'active':form_data.state == 1}">历史班级</span>
                    </div>
                    <div class="search_box_right">
                        <el-input v-model="form_data.keyword" :clearable="true" @input="changKeyword" placeholder="请输入班级名称"></el-input>
                    </div>
                </div>


                <div class="statistics_chart_box">
                    <div class="statistics_chart_box_title">
                        本月做题统计
                    </div>
                    <selfChartLeftComponent :state="form_data.state"></selfChartLeftComponent>
                </div>

                <div class="statistics_plan_box_title">
                    班级统计
                </div>

                <div class="statistics_plan_list">
                    <div class="statistics_plan_list_item" v-for="(item,index) in plan_data" :key="index">
                        <div class="statistics_plan_list_item_title">
                            <span class="title">{{item.plan_name}}</span>
                            <el-tag size="small">{{item.total_student}}人</el-tag>
                        </div>
                        <div class="statistics_plan_list_tag">
                            <div class="tag_item">
                                <div class="statistics_plan_tag_value">
                                    <span class="tag_value">{{item.study_student}}</span>
                                    <span class="tag_unit">人</span>
                                </div>
                                
                                <span class="tag_name">学习人数</span>
                                
                            </div>
                            <div class="tag_item">
                                <div class="statistics_plan_tag_value">
                                    <span class="tag_value">{{item.avg_score}}</span>
                                    <span class="tag_unit">%</span>
                                </div>
                                <span class="tag_name">平均正确率</span>     
                            </div>
                            <div class="tag_item">
                                
                                <span class="tag_value">{{item.total_study_time}}</span>
                                <span class="tag_name">学习时长</span>     
                            </div>
                            <div class="tag_item">
                                <div class="statistics_plan_tag_value">
                                    <span class="tag_value">{{item.total_question_count}}</span>
                                    <span class="tag_unit">篇</span>
                                </div>
                                <span class="tag_name">练习题量</span>     
                            </div>
                        </div>
                        <div style="margin-top: 20px;">
                            <el-button @click="$router.push({name:'Statisticsdetail',query:{plan_id:item.plan_id,plan_name:item.plan_name,state:form_data.state}})" type="primary" size="small" class="el-icon-edit"> 查看详情</el-button>
                        </div>
                    </div>
                </div>


                <el-empty v-if="!plan_data.length" description="暂无数据"></el-empty>

                <!-- <div class="label_button_box">
      
                    <div class="label_button_box_right">
                        <el-input v-model="keyword" size="small" :clearable="true" @input="changKeyword" placeholder="请输入班级名称></el-input>

                    </div>
                </div> -->
                <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="当前班级" name="first">
                        <div class="label_button_box">
      
                            <div class="label_button_box_right">
                                <el-input v-model="keyword" size="small" :clearable="true" @input="changKeyword" placeholder="请输入班级名称"></el-input>

                            </div>
                        </div> 
                    </el-tab-pane>
                    <el-tab-pane label="历史班级" name="second"></el-tab-pane>
                </el-tabs>
                <Skeleton v-if="loading" :skeleton_type="'image_text'"></Skeleton>
                <div v-if="!loading" class="_list">
                    <el-col v-if="!plan_data.length" :span="24">
                        <el-empty description="未创建班级"></el-empty>
                    </el-col>
                    <el-col v-for="(item,index) in plan_data" :key="index" :span="24">
                        
                        <el-card shadow="hover">
                 
                            <div class="list_thumb">
                                <img v-if="!item.image" src="../../../static/image/bjtp-mr4.png" />
                                <img v-if="item.image" :src="item.image" />
                                <img class="plan_tage" v-if="item.status == 1" src="../../../static/image/dlbj.png">
                                <img class="plan_tage" v-if="item.status == 0" src="../../../static/image/zrbj.png">
                            </div>
                            <div class="list_info">
                                <div class="list_info_text" style="font-weight: 700;">{{ item.name }}</div>
                                <div class="list_info_text">
                                    <span>年级: {{ item.grade_text }}</span>
                                    <span>学院: {{ item.college }}</span>
                                    <span>专业: {{ item.specialty }}</span>
                                </div>
                                <div class="list_info_text">人数: {{ item.number }}</div>
                            </div>
                            <div class="list_right">
            
                            
                                <el-button size="small" @click="Statisticsdetail(item.plan_id,item.name)" type="primary">查看详情</el-button>
                            
                            </div>
                        </el-card>
                    </el-col> -->

                    <el-pagination
                        style="margin-top:25px"
                        background
                        hide-on-single-page
                        @size-change="changeSize"
                        @current-change="changeNumber"
                        :page-size="form_data.pageSize"
                        :current-page="form_data.page"
                        :total="total_number">
                    </el-pagination>
                </div>
                    

                
    </div>
</template>
<script>
import Http from "../../apis/teach";
import selfChartLeftComponent from "../../../untils/chart/selfchart.vue";

export default {
    components:{
        selfChartLeftComponent
    },
    data(){
        return{
            
            loading:true,
            keyword:'',
            total_number:0,
            plan_data:[],
            form_data:{
                page:1,
                pageSize:9,
                state:0,
                keyword:''
            },
        }
    },

    created() {
        this.getList()
    },

    methods:{
        // 切换tab
        changeTab(index){
            this.form_data.state = index
            this.getList();
        },
        // 获取班级列表
        // state 0 管理中的班级码历史班级
        getList(){
            const loading = this.$loading({
                lock: true,
                text: '疯狂加载中..',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            Http.selfPlan(this.form_data).then((res) => {
                
                loading.close()
                this.plan_data = res.data.list
                this.total_number = res.data.total
            });
        },


        // 点击页码
        changeNumber(e){
            this.form_data.page = e
            this.getList()
        },

        // 前往指定页数
        changeSize(e){
            this.form_data.page = e
            this.getList()
        },
        // 搜索班级
        changKeyword(value){
            this.form_data.keyword = value
            this.getList();
        },

        Statisticsdetail(plan_id,plan_name){
            var _this = this
            _this.$router.push({name:'Statisticsdetail',query:{plan_id:plan_id,plan_name:plan_name,state:this.form_data.state}});
        },
        handleClick(tab, event){
            this.form_data.state = tab.index
            this.getList();
        },
    }
}
</script>

<style scoped>

.top_label{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    
}
.lable_name{
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}
.stattistic_search_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
}
.search_box_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}
.search_box_left span{
    cursor: pointer;
    padding: 8px 10px;
    border-radius: 5px;
    font-size: 14px;
}

.search_box_left span.active{
    background: #409eff;
    color: #fff;
}

.search_box_left span:hover{
    background: #409eff;
    color: #fff;
}
.search_box_right{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.statistics_plan_list{
    margin-top: 25px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}
.statistics_plan_list_item{
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    transition: all 0.3s ease;
}

.statistics_plan_list_item:hover{
    transform: translateY(-5px);
}

.statistics_chart_box{
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    margin-top: 20px;
}
.statistics_chart_box_title{
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    text-align: left;
}
.statistics_plan_box_title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    margin-top: 20px;
}



.statistics_plan_list_item_title{
    
    color: #000000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}
.statistics_plan_list_item_title .title{
    font-size: 16px;
    font-weight: 700;
}
.statistics_plan_list_tag{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    margin-top: 20px;
}
.statistics_plan_list_tag .tag_item{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 10px;
    border-radius: 5px;
    background: #ECF5FF;
}
.statistics_plan_list_tag .tag_item .tag_value{
    font-size: 16px;
    font-weight: 700;
    color: #000000;
}
.statistics_plan_list_tag .tag_item .tag_name{
    font-size: 12px;
    font-weight: 400;
    color: #000000;
}
.statistics_plan_tag_value{
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 5px;
}
.statistics_plan_list_tag .tag_item .tag_unit{
    font-size: 12px;
}

</style>